import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import TableDefault from "../../../../components/grid/TableDefault";
import { formatDate } from "../../../../utils/formatDate";
import MaskService from "../../../../utils/mask/maskService";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import moment from "moment";

let typingTimer = null;

const BodySearchPaymentsReceipts = ({
  suggestions = [],
  items = [],
  setItems = () => {},
  type = "",
  totalItens = 0,
  filter = "",
  setFilter = () => {},
}) => {
  const rowsPerPage = 10;
  const quantidadePorPesquisa = 50;

  const [loadingTable, setLoadingTable] = useState(false);
  const [pagePropDefault, setPagePropDefault] = useState(0);

  const { getReceiptsbills, getPaybills } = useConciliacaoBancariaController();

  const customHandleChangePage = async (event, page, itemIndex) => {
    if (!type) return [];

    setLoadingTable(true);
    let pageCarregar = Math.round(itemIndex / quantidadePorPesquisa + 1);
    let itens;
    if (type === "D") {
      itens = await getPaybills(pageCarregar, true, filter);
    }
    if (type === "C") {
      itens = await getReceiptsbills(pageCarregar, true, filter);
    }
    setLoadingTable(false);

    return itens.data;
  };

  const searchItems = async (textFilter) => {
    setFilter(textFilter);
    if (!type) return [];

    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      setLoadingTable(true);

      if (type === "D") {
        await getPaybills(1, false, textFilter);
        setLoadingTable(false);
      }
      if (type === "C") {
        await getReceiptsbills(1, false, textFilter);
        setLoadingTable(false);
      }
    }, 2000);
  };

  let columns = [
    {
      label: "ID",
      id: "id",
    },
    {
      label: "Data Vencimento",
      id: "datavencto",
      format: (item) => {
        let getStandardDate = !!item.datavencto;

        if (getStandardDate)
          return moment(item.datavencto).format("DD/MM/YYYY");
        else {
          return "-";
        }
      },
    },
    {
      label: "Participante",
      id: "participante",
      format: (item) => {
        if (item.fornecedor) {
          return item.fornecedor.razao;
        } else if (item.cliente) {
          return item.cliente.razao;
        }
      },
    },
    {
      label: "Nº Doc.",
      id: "numerodocto",
    },
    {
      label: "Descrição",
      id: "historico",
    },
    {
      label: "Valor",
      id: "valordocto",
      format: (item) => `R$ ${MaskService.toMask("decimal", item.valordocto)}`,
    },

    {
      label: "Situação",
      id: "sit",
      format: (item) => item?.situation ?? "Outros",
    },
  ];

  useEffect(() => {
    setPagePropDefault(0);
  }, [filter]);

  return (
    <Grid>
      <Grid item container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs>
          <TextFieldErp
            value={filter}
            onChange={(e) => {
              searchItems(e.target.value);
            }}
            label="Busque por ID, Data Vencimento, Nome Participante, Nº do Documento, Descrição ou Valor"
            variant="filled"
          />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <TableDefault
          selected={items || []}
          setSelected={setItems}
          smallFont
          selectable
          columns={columns}
          values={suggestions}
          loading={loadingTable}
          quantidadeItensTotal={totalItens}
          rowsPerPage={rowsPerPage}
          customHandleChangePage={customHandleChangePage}
          pageProp={pagePropDefault}
          setPageProp={setPagePropDefault}
          rowId="typeBillID"
          customDisableCheckAll={true}
        />
      </Grid>
    </Grid>
  );
};

export default BodySearchPaymentsReceipts;
